export default __webpack_public_path__ + "static/media/empty_data.5447bcd8.svg";